import { Languages } from "../../enums/languages";



const buttonLang = {
    "send-form": {
        [Languages.Hebrew]: { default: "שלח טופס" },
        [Languages.Arabic]: { default: "إرسال النموذج" },
        [Languages.English]: { default: "Send Form" }
    },
    "return-home": {
        [Languages.Hebrew]: { default: "חזרה לדף הבית" },
        [Languages.Arabic]: { default: "العودة إلى الصفحة الرئيسية" },
        [Languages.English]: { default: "Return Home" }
    },
}

export default buttonLang;